define('SageDotCom/Components/Content/SelectDropDown',["jquery", "eventManager"],
    function ($, eventManager) {

        function SelectDropDown(scope, targetId, bindingParent, eventNamespace) {
            const $dropdown = $(".select-drop-down", scope);
            const $dropdownContent = $(".select-drop-down-option-list", scope);
            const $dropdownSelectedOption = $dropdown.find(".select-drop-down-toggle");
            const $bindingParentEl = $dropdown.parents(bindingParent);
            let freshList = true;
            
            const showDropdown = () => {
                const toggleRect = $dropdownSelectedOption.get(0).getBoundingClientRect();
                const topPos = toggleRect.top;
                const $bindingParentElRect = $bindingParentEl.get(0).getBoundingClientRect();
                const bindingHeight = $bindingParentElRect.height;

                $dropdownContent.height("auto");
                $dropdownContent.show();
                $dropdownSelectedOption.attr("aria-expanded", true);
                const listBindingRect = $dropdownContent.get(0).getBoundingClientRect();

                const availableHeight = bindingHeight - topPos;

                if (listBindingRect.height > availableHeight) {
                    $dropdownContent.height(availableHeight);
                }


                //Get the remaining height of the containing element
                //i.e. height of controlling element (defined when this is called) - position of toggle relative to that element
                //remaining value is the max height of the list

                $("body").on("click." + eventNamespace,
                    function (ev) {
                        var $target = $(ev.target);
                        if (!$target.closest(".select-drop-down").length && $dropdownContent.is(":visible")) {
                            hideDropdown();
                        }
                    });
            }

            const hideDropdown = () => {
                $dropdownContent.hide();
                $dropdownSelectedOption.attr("aria-expanded", false);

                $("body").off("click." + eventNamespace);
            }

            const updateDropdown = (selectedOption) => {
                hideDropdown();
                $dropdownContent.find(".select-drop-down-item.selected").removeClass("selected");
                $(selectedOption).addClass("selected");
                $dropdownSelectedOption.html(selectedOption.innerHTML);
                const identifier = $(selectedOption).attr("identifier");
                const index = $(selectedOption).attr("index");
                const variant = $(selectedOption).attr("variant");

                eventManager.trigger(`select-drop-down-option-selected-${targetId}`, { identifier: identifier, index: index, variant:variant, freshList: freshList });
                freshList = false;
            };

            const selectOptionWithIdentifier = function (identifier, variant) {
                let selectedOption;
                if (variant) {
                    selectedOption = $dropdownContent.find(`[identifier="${identifier}"][variant="${variant}"]`);
                } else {
                    selectedOption = $dropdownContent.find(`[identifier="${identifier}"]`);
                }
                if (selectedOption.length) {
                    updateDropdown(selectedOption.get(0));
                }
            };

            eventManager.subscribe(`select-drop-down-option-select-option-${targetId}`, selectOptionWithIdentifier);

            $dropdownSelectedOption.on("click", showDropdown);
            $dropdownContent.on("click",
                ".select-drop-down-item",
                function (ev) {
                    updateDropdown(ev.currentTarget);
                });

            $dropdownContent.on("keydown",
                function(ev) {
                    if (ev.keyCode === 40 || ev.keyCode === 38) {
                        const targetBtn = $(ev.target);
                        const parentLi = targetBtn.closest(".select-drop-down-list-item");
                        if (ev.keyCode === 40) {
                            //down
                            let nextSibling = $(parentLi.get(0).nextSibling);
                            if (nextSibling.length === 0) {
                                nextSibling = $dropdownContent.find(".select-drop-down-list-item").first();
                            }
                            nextSibling.find(".select-drop-down-item").trigger("focus");
                        }
                        if (ev.keyCode === 38) {
                            //up
                            let prevSibling = $(parentLi.get(0).previousSibling);
                            if (prevSibling.length === 0) {
                                prevSibling = $dropdownContent.find(".select-drop-down-list-item").last();
                            }
                            prevSibling.find(".select-drop-down-item").trigger("focus");
                        }
                    }
                });

            eventManager.subscribe(`select-drop-down-clear-${targetId}`,
                function () {
                    $dropdownContent.empty();
                    freshList = true;
                });

            const addOption = function (optionHtml, index, identifier, variant) {
                const optionObj = document.createElement("li");
                $(optionObj).attr("role", "option");
                $(optionObj).addClass("select-drop-down-list-item");
                const innerLink = document.createElement("button");
                $(innerLink).addClass("select-drop-down-item");
                //Identifier needs to be unique, but not necessarily id - could be multiple on the page, needs to be unique in the list
                $(innerLink).attr("identifier", identifier);
                $(innerLink).attr("variant", variant);
                $(innerLink).attr("index", index);
                $(innerLink).attr("tabindex", 0);
                innerLink.innerHTML = "<div class='select-drop-down-option-content'>" + optionHtml + "</div>";
                optionObj.append(innerLink);
                $dropdownContent.append(optionObj);
            }

            eventManager.subscribe(`select-drop-down-add-option-${targetId}`,
                function (data) {
                    const startIndex = $dropdownContent.find(".select-drop-down-item").length - 1;
                    addOption(data.optionHtml, startIndex + 1, data.identifier, data.variant);
                });

            eventManager.subscribe(`select-drop-down-add-options-${targetId}`,
                function (data) {
                    const startIndex = $dropdownContent.find(".select-drop-down-item").length - 1;
                    for (var i = 0; i < data.options.length; i++) {
                        addOption(data.options[i].optionHtml, startIndex + i + 1, data.options[i].identifier, data.options[i].variant);
                    }
                });

            eventManager.subscribe(`select-drop-down-replace-options-${targetId}`,
                function (data) {
                    $dropdownContent.empty();
                    if (data.options.length > 0) {
                        freshList = true;

                        for (var i = 0; i < data.options.length; i++) {
                            addOption(data.options[i].optionHtml, i, data.options[i].identifier, data.options[i].variant);
                        }
                        selectOptionWithIdentifier(data.options[0].identifier, data.options[0].variant);
                    }
                });
        }

        SelectDropDown.init = function init(args) {
            return new SelectDropDown(args.scope, args.targetId, args.bindingParent, args.eventNamespace);
        };

        return SelectDropDown;
    });
